import React from "react";
import {arraysEqual } from 'helpers/utils'
import { usePositions } from "components/common/Positions";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { GGetSportsCode, GetSportsCodefromNote } from "../SportCode";

export const TeamEntriesExpanded = React.memo((props) => {
    const { mirs_discipline } = useUrlFriendlyToParameters();
    const { row, sportEntryCodes } = props;
    const positions = usePositions();
    const orderMap = new Map(sportEntryCodes.map(element => [element?.sportCode, element?.order?.trim()]));
    const data = row?.person?.registeredEvents?.at(0)?.eventEntries?.sort((a, b) => orderMap.get(a.ee_code) - orderMap.get(b.ee_code));
    // const data = row?.person?.registeredEvents?.[0]?.eventEntries

    const isCodeVisible = code => (sportEntryCodes?.find(se => se?.sportCode === code)?.order > 9)

    const getSportCodeDecription = code => sportEntryCodes?.find(se => se?.sportCode === code)?.description || code;

    const getCodeValue = (codeEntry) => {
        let codeValue = "";
        switch (codeEntry.ee_code) {
            case "POSITION":
                codeValue = positions(codeEntry.ee_value);
                break;
            default:
                codeValue = codeEntry.ee_value;
                break;
        }
        return codeValue;
    }
    return (
        <table className="table table-detail">
            <thead>
                <tr>
                    {data?.map(ee => (
                        isCodeVisible(ee?.ee_code) && <th key={ee.ee_code}>{getSportCodeDecription(ee?.ee_code)}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                <tr>
                    {data?.map(ee => {
                        let entry = sportEntryCodes?.find( spEntry => spEntry?.disciplineCode === mirs_discipline && spEntry?.sportCode === ee?.ee_code);                        
                        // return isCodeVisible(ee?.ee_code) && <td key={ee.ee_code}><>{xx?.note ? GetSportsCodefromNote(mirs_discipline, xx?.note, ee?.ee_value)?.description: getCodeValue(ee)}</></td>
                        //let x = entry?.note ? GGetSportsCode(mirs_discipline, entry?.note, ee):ee?.ee_value;
                        // return isCodeVisible(ee?.ee_code) && <td key={ee.ee_code}><>{entry?.note ? GetSportsCodefromNote(mirs_discipline, entry?.note, ee?.ee_value)?.description: ee?.ee_value}</></td>
                        return isCodeVisible(ee?.ee_code) && <td key={ee.ee_code}><>{entry?.note ? GGetSportsCode(mirs_discipline, entry?.note, ee)?.description: ee?.ee_value}</></td>
                    })}
                </tr>
            </tbody>
        </table>
    );
}, (prevProps, nextProps) => {
    //Si retornamos true:  No se renderiza
    //Si retornamos false: Si se renderiza
    return (
        //renderizamos cuando un dato de los visibles cambia
        arraysEqual(prevProps.row, nextProps.row)
    )
});